import { render, staticRenderFns } from "./DetailInventory.vue?vue&type=template&id=4e95af3e&"
import script from "./DetailInventory.ts?vue&type=script&lang=ts&"
export * from "./DetailInventory.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports